import styled from "@emotion/styled";

export const BodyModal = styled.div`
  .popup-box {
    position: absolute;
    background: ${props => props.theme.bodyModal.popupBoxBackground};
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 99999;
    display: none;
    padding: ${props => props.customStyle.fullScreen ? 0 : 15}px;

    &.in {
      display: block;

      .box {
        transform: scale(0);
        animation: ${props => props.theme.roadRunnerIn} 0.5s .1s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
      }
    }

    &.out {
      display: block;

      .box {
        transform: scale(1);
        animation: ${props => props.theme.roadRunnerOut} 0.5s .1s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
      }
    }
  }

  .box {
    position: relative;
    width: 100%;
    height: 100%;
    background: ${props => props.theme.palette.background.default};
    border-radius: ${props => props.customStyle.fullScreen ? 0 : 4}px;
    overflow: auto;
    padding: 18px 32px;
  }
`;
